<template>
  <el-container class="login_bg" type="flex" style="height:100%">
  <el-main>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item v-for="(item, index) in indexPath" :key="index">{{ item.split('-')[1] }}</el-breadcrumb-item>
      <el-breadcrumb-item>开票详情</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form ref="editForm" size="small" :model="editForm" label-position="left" label-width="80px"
      style="width:50%;margin-top:30px">
      <h4>订单信息
        <el-button size="small" class="yellow_btn" icon="el-icon-plus" @click="changeOrder">选择订单
        </el-button>
      </h4>
      <el-form-item label="订单编号" prop="OrderId" :rules="[
        { required: true, message: '请选择订单', trigger: 'blur' }
      ]">
        {{ editForm.OrderId }}
        <!-- <el-select v-model="select" multiple placeholder="请选择订单">
          <el-option label="20221201121011-普通版-￥6,200-2022/12/8 10:00:00" value="1"></el-option>
          <el-option label="20221201121011-普通版-￥6,200-2022/12/8 10:00:00" value="2"></el-option>
          <el-option label="20221201121011-普通版-￥6,200-2022/12/8 10:00:00" value="3"></el-option>
        </el-select> -->
      </el-form-item>
      <el-form-item label="开票金额" :rules="[
        { required: true, message: '请选择订单', trigger: 'blur' }
      ]">
        {{ editForm.InvoiceAmount }}
      </el-form-item>
      <h4>发票信息</h4>
      <el-form-item label="抬头名称" prop="headIndex" :rules="[
        { required: true, message: '请选择抬头名称', trigger: 'blur' }
      ]" placeholder="请选择">
        <el-select v-model="editForm.headIndex" placeholder="请选择" @change="handleChangeHead">
          <el-option v-for="(item, index) in HeadList" :key="index" :label="item.headingName" :value="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发票性质" prop="invoiceNature" :rules="[
        { required: true, message: '请选择发票性质', trigger: 'blur' }
      ]" placeholder="请选择">
        <el-radio-group v-model="editForm.invoiceNature" @change="handleChangeInvoiceNature">
          <el-radio label="1">电子发票</el-radio>
          <el-radio label="2">纸质发票</el-radio>
        </el-radio-group>
      </el-form-item>
      <div style="font-size: 14px;color: #606266;line-height: 30px;">
        <div>抬头类型：{{ code.invoiceType[editForm.headingType] }}</div>
        <div>发票类型：{{ code.invoiceType[editForm.invoiceType] }}</div>
        <div>纳税人识别号：{{ editForm.identificationCode }}</div>
        <div>发票内容：{{ code.invoiceContent[1] }}</div>
        <div>企业地址：{{ editForm.headingAddr }}</div>
        <div>联系电话：{{ editForm.contactTel }}</div>
        <div>开户行：{{ editForm.bankDeposit }}</div>
        <div>银行账号：{{ editForm.bankAccount }}</div>
        <div>备注：{{ editForm.remark }}</div>
      </div>
      <!-- <el-form-item label="发票类型" prop="name" :rules="[
                    { required: true, message: '请选择发票类型', trigger: 'blur' }
                    ]">
        <el-radio-group v-model="editForm.resource">
          <el-radio :label="0">普通发票</el-radio>
          <el-radio :label="1">专用发票</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="抬头类型" prop="name" :rules="[
                    { required: true, message: '请选择抬头类型', trigger: 'blur' }
                    ]">
        <el-radio-group v-model="editForm.resource">
          <el-radio :label="0">企业</el-radio>
          <el-radio :label="1">个人</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="发票性质" prop="name" :rules="[
                    { required: true, message: '请选择发票性质', trigger: 'blur' }
                    ]">
        <el-radio-group v-model="editForm.resource">
          <el-radio :label="0">电子普通发票</el-radio>
          <el-radio :label="1">纸质发票</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="纳税人识别号" prop="name" :rules="[
                    { required: true, message: '请输入纳税人识别号', trigger: 'blur' }
                    ]" placeholder="请输入">
        <el-input v-model="editForm.desc"></el-input>
      </el-form-item>
      <el-form-item label="发票内容" prop="name" :rules="[
                    { required: true, message: '请选择发票内容', trigger: 'blur' }
                    ]">
        <el-radio v-model="editForm.resource" :label="0">技术服务费</el-radio>
      </el-form-item>
      <el-form-item label="联系电话" prop="name">
        <el-input v-model="editForm.desc" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="企业地址" prop="name">
        <el-input v-model="editForm.desc" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="开户行" prop="name">
        <el-input v-model="editForm.desc" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="银行账号" prop="name">
        <el-input v-model="editForm.desc" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input type="textarea" v-model="editForm.desc" placeholder="请输入"></el-input>
      </el-form-item> -->
      <el-form-item label="设为默认" v-if="editForm.default == 0">
        <el-checkbox v-model="editForm.isDefault" @change="handleChangeHeadSet"></el-checkbox>
      </el-form-item>
      <h4>邮寄信息
        <el-button size="small" class="yellow_btn" icon="el-icon-plus" v-if="editForm.invoiceNature == 2"
          @click="handleChooseAddress">选择地址
        </el-button>
      </h4>
      <!-- <el-form-item label="邮寄地址" prop="name" :rules="[
                    { required: true, message: '请选择邮寄地址', trigger: 'blur' }
                    ]" placeholder="请选择">
        <el-select v-model="editForm.region" placeholder="请选择">
          <el-option v-for="(item,index) in list" :key="index" :label="item.name" :value="item.code"></el-option>
          <el-option label="收货人-13456789021-杭州市拱墅区XXXXXXX" value="1"></el-option>
          <el-option label="收货人-13456789021-杭州市拱墅区XXXXXXX" value="2"></el-option>
          <el-option label="收货人-13456789021-杭州市拱墅区XXXXXXX" value="3"></el-option>
        </el-select>
      </el-form-item> -->
      <div style="font-size: 14px;color: #606266;line-height: 30px;">
        <div v-if="editForm.invoiceNature == 2">
          <div>收货人：{{ editForm.mailContactUser }}</div>
          <div>联系电话：{{ editForm.mailContactTel }}</div>
          <div>收货地址：{{ editForm.mailAddr }}</div>
          <div>邮编：{{ editForm.postalCode }}</div>
        </div>
        <div v-if="editForm.invoiceNature == 1">邮箱：{{ editForm.email }}</div>
      </div>
      <el-form-item style="margin-top: 30px;">
        <el-button @click="resetForm('editForm')">重 置</el-button>
        <el-button type="primary" :disabled="btnDisabled" @click="submitForm('editForm')">提交申请</el-button>
      </el-form-item>
    </el-form>
    <el-dialog title="选择订单" :visible.sync="dialogVisibleOrder" width="60%" center :close-on-click-modal="false"
      :show-close="false">
      <div class="">已选订单：{{ selectOrder.join(',') }}</div>
      <div class="">金额：{{ selectOrderAcount.toFixed(2) }}</div>
      <el-table border ref="tableDataOrder" :data="tableDataOrder" row-key="id" @selection-change="handleSelectioOrder">
        <el-table-column type="selection" width="55" :reserve-selection="true">
        </el-table-column>
        <el-table-column prop="id" label="订单号"></el-table-column>
        <el-table-column prop="packageName" label="软件名称"></el-table-column>
        <el-table-column prop="amount" label="订单金额"></el-table-column>
        <el-table-column prop="amount" label="开具金额"></el-table-column>
        <el-table-column prop="payTime" label="支付时间"></el-table-column>
      </el-table>
      <el-pagination @current-change="handleCurrentChangeOrder" @size-change="handleSizeChangeOrder"
        :current-page="formInlineOrder.Page" :page-sizes="[10, 15, 20]" layout="total, sizes, prev, pager, next, jumper"
        :total="totalOrder" hide-on-single-page>
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="beforeCloseOrder">取 消</el-button>
        <el-button type="primary" @click="addOrder">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="选择地址" :visible.sync="dialogVisibleAddress" width="60%" center :close-on-click-modal="false"
      :show-close="false">
      <el-table border ref="singleTable" :data="tableDataAddress" row-key="id" highlight-current-row
        @current-change="handleChangeAddress">
        <el-table-column prop="receivdFullName" label="收货人"></el-table-column>
        <el-table-column prop="tips" label="收货地址">
          <template slot-scope="scope">
            {{ scope.row.revicedProvinceName + scope.row.provinceCityName + scope.row.provinceAreaName +
              scope.row.receivdAddr }}
          </template>
        </el-table-column>
        <el-table-column prop="receivdTel" label="联系电话"></el-table-column>
      </el-table>
      <el-pagination @current-change="handleCurrentChangeAddress" @size-change="handleSizeChangeAddress"
        :current-page="formInlineAddress.page" :page-sizes="[10, 15, 20]" layout="total, sizes, prev, pager, next, jumper"
        :total="totalAddress" hide-on-single-page>
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="beforeCloseAddress">取 消</el-button>
        <el-button type="primary" @click="addAddress">确 定</el-button>
      </span>
    </el-dialog>
  </el-main>

  <div class="footer-copyright">Copyright@2016-2023杭州闪派网络科技有限公司版权所有 网站备案/许可证号：
      <a href="https://beian.miit.gov.cn/" target="“_blank&quot;">浙ICP备16031137号</a>
      <img :src="require('@/assets/images/gongan.png')" alt="" style="vertical-align: middle;margin-left: 10px;"> 浙公网安备案
      <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010502007569"
        target="“_blank&quot;">33010502007569</a>
    </div>
  </el-container>
</template>
<script>
import {
  getHeadingList,
  getMailList,
  getBasicInfo,
  setDefaultHeading,
  getPurchaseRecordList,
  applyForInvoice
} from '@/api.js'
import {
  mapState
} from 'vuex'
export default {
  name: "CompanyAttestation",
  data() {
    return {
      HeadList: [],
      dialogVisibleOrder: false,
      formInlineOrder: {
        CanInvoice: 1,
        OrderStatus: 2,
        Page: 1,
        Size: 10
      },
      totalOrder: 0,
      tableDataOrder: [],
      selectOrder: [],
      selectOrderAcount: 0.00,

      dialogVisibleAddress: false,
      formInlineAddress: {
        page: 1,
        pageSize: 10
      },
      totalAddress: 0,
      tableDataAddress: [],
      mailAddr: {},
      editForm: {
        OrderId: '',
        InvoiceAmount: '',
        headIndex: '',
        invoiceType: '',
        headingType: '',
        invoiceNature: '',
        invoiceAmount: '',
        headingName: '',
        identificationCode: '',
        invoiceContent: '',
        contactTel: '',
        headingAddr: '',
        bankDeposit: '',
        bankAccount: '',
        remark: '',
        isDefault: '',
        mailId: '',
        mailAddr: '',
        mailContactUser: '',
        mailContactTel: '',
        postalCode: '',
        email: ''
      },
    }
  },
  created() {
    this.getHeadingList()
  },
  mounted() {

  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.btnDisabled = true
          applyForInvoice(this.editForm).then(res => {
            this.btnDisabled = false;
            if (res.code == 0) {
              this.$message.success(res.message);
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    changeOrder() {
      this.dialogVisibleOrder = true
      if (this.editForm.OrderId == '') {
        this.$nextTick(() => {
          this.$refs['tableDataOrder'].clearSelection()
        })
      }
      this.getTableDateOrder()
    },
    // 是否可以勾选
    // "invoiceStatus": 0 //-1=未开票 发票状态 0=待处理1=处理中2=开票成功3=审核通过4=撤销5已拒绝
    // selectable(row) {
    //   if (row.invoiceStatus == -1 || row.invoiceStatus == 4 || row.invoiceStatus == 5) {
    //     return true
    //   } else {
    //     return false
    //   }
    // },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.selectOrder = []
      this.selectOrderAcount = 0.00
      this.tableDataOrder = []
      this.editForm = {
        OrderId: '',
        InvoiceAmount: '',
        headIndex: '',
        invoiceType: '',
        headingType: '',
        invoiceNature: '',
        invoiceAmount: '',
        headingName: '',
        identificationCode: '',
        invoiceContent: '',
        contactTel: '',
        headingAddr: '',
        bankDeposit: '',
        bankAccount: '',
        remark: '',
        isDefault: '',
        mailId: '',
        mailAddr: '',
        mailContactUser: '',
        mailContactTel: '',
        postalCode: '',
        email: ''
      }
    },
    //订单
    getTableDateOrder() {
      getPurchaseRecordList(this.formInlineOrder).then(res => {
        if (res.code == 0) {
          this.tableDataOrder = res.data.list
          this.totalOrder = res.data.total
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleCurrentChangeOrder(val) {
      this.formInlineOrder.page = val
      this.getTableDateOrder()
    },
    handleSizeChangeOrder(val) {
      this.formInlineOrder.page = 1
      this.formInlineOrder.pageSize = val
      this.getTableDateOrder()
    },
    handleSelectioOrder(selection) {
      this.selectOrder = []
      this.selectOrderAcount = 0
      selection.forEach(item => {
        this.selectOrder.push(item.id)
        this.selectOrderAcount += item.amount
      })
    },
    addOrder() {
      this.dialogVisibleOrder = false
      this.editForm.OrderId = this.selectOrder.join(',')
      this.editForm.InvoiceAmount = this.selectOrderAcount
    },
    beforeCloseOrder() {
      this.$refs['tableDataOrder'].clearSelection()
      this.selectOrder = []
      this.selectOrderAcount = 0.00
      this.editForm.OrderId = ''
      this.editForm.InvoiceAmount = 0.00
      this.dialogVisibleOrder = false
    },
    // 发票
    getHeadingList() {
      getHeadingList({
        size: -1
      }).then(res => {
        if (res.code == 0) {
          this.HeadList = res.data.list
          const head = this.HeadList.find((item) => {
            return item.isDefault == 1
          })
          this.editForm.headIndex = head ? '' : head
          this.setInvoiceInfo(head)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleChangeHead(val) {
      this.setInvoiceInfo(this.HeadList[val])
    },
    setInvoiceInfo(head) {
      this.editForm.headId = head.id
      this.editForm.invoiceType = head.invoiceType
      this.editForm.headingType = head.headingType
      this.editForm.invoiceNature = head.invoiceNature
      this.editForm.invoiceAmount = head.invoiceAmount
      this.editForm.headingName = head.headingName
      this.editForm.identificationCode = head.identificationCode
      this.editForm.invoiceContent = head.invoiceContent
      this.editForm.contactTel = head.contactTel
      this.editForm.headingAddr = head.headingAddr
      this.editForm.bankDeposit = head.bankDeposit
      this.editForm.bankAccount = head.bankAccount
      this.editForm.remark = head.remark
      this.editForm.email = head.email
      this.editForm.isDefault = head.isDefault == 0 ? false : true
    },
    handleChangeHeadSet() {
      this.$confirm('此操作將该抬头设为默认发票抬头, 是否继续？', '提 示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        center: true
      }).then(() => {
        setDefaultHeading({
          id: this.editForm.headId
        }).then(res => {
          if (res.code == 0) {
            this.$message.success(res.ErrorMsg);
            this.getTableDate();
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => {

      });
    },
    handleChangeInvoiceNature(val) {
      if (val == 2) {
        this.getTableDateAddress()
      } else {
        this.getBasicInfo()
      }
    },
    //地址
    handleChooseAddress() {
      this.dialogVisibleAddress = true
      this.getTableDateAddress()
      const address = this.tableDataAddress.find(item => {
        return item.id == this.editForm.mailId
      })
      this.$nextTick(() => {
        this.$refs.singleTable.setCurrentRow(address)
      })
    },
    getTableDateAddress() {
      getMailList().then(res => {
        if (res.code == 0) {
          this.tableDataAddress = res.data.list
          const address = this.tableDataAddress.find((item) => {
            return item.isDefault == 1
          })
          if (this.tableDataAddress) {
            this.setAddressInfo(address)
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleCurrentChangeAddress(val) {
      this.formInlineAddress.page = val
      this.getTableDateAddress()
    },
    handleSizeChangeAddress(val) {
      this.formInlineAddress.page = 1
      this.formInlineAddress.pageSize = val
      this.getTableDateAddress()
    },
    handleChangeAddress(row) {
      this.mailAddr = row
    },
    setAddressInfo(row) {
      this.editForm.mailId = row.id
      this.editForm.mailAddr = row.revicedProvinceName + row.provinceCityName + row.provinceAreaName + row.receivdAddr
      this.editForm.mailContactUser = row.receivdFullName
      this.editForm.mailContactTel = row.receivdTel
      this.editForm.postalCode = row.postalCode
    },
    addAddress() {
      this.setAddressInfo(this.mailAddr)
      this.dialogVisibleAddress = false
    },
    beforeCloseAddress() {
      this.dialogVisibleAddress = false
    },
    // 邮箱
    getBasicInfo() {
      getBasicInfo().then(res => {
        if (res.code == 0) {
          this.editForm.email = res.data.companyBasicInfo.email
        } else {
          this.$message.error(res.message)
        }
      })
    },

  },
  computed: {
    ...mapState({
      indexPath: state => state.indexPath,
      code: state => state.code,
    }),
  },
}
</script>

<style scoped lang="scss">
.el-container {
  flex-direction: column;

  .footer-copyright {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
  }
}
h4 {
  margin: 15px 0;

  .el-button {
    float: right
  }
}

.el-select {
  width: 60%;
}
</style>